var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 105.209,
    height: 121.698,
    viewBox: "0 0 105.209 121.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13915",
    "data-name": "Group 13915",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11263",
    "data-name": "Path 11263",
    d: "M27.172,49.641h16.14V82.3a4.015,4.015,0,0,0,4.067,4.067H67.2A4.015,4.015,0,0,0,71.27,82.3V49.641H87.41a4.132,4.132,0,0,0,3.3-6.608L60.6,4.145a4.051,4.051,0,0,0-6.481,0L24,43.033A4.054,4.054,0,0,0,27.172,49.641Z",
    transform: "translate(-5.187 -2.525)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11264",
    "data-name": "Path 11264",
    d: "M110.286,62.8H94.528A2.876,2.876,0,0,0,91.6,65.723V84.4a.869.869,0,0,1-.89.89H31.494a.869.869,0,0,1-.89-.89V65.723A2.876,2.876,0,0,0,27.681,62.8H11.923A2.876,2.876,0,0,0,9,65.723v38.252a2.876,2.876,0,0,0,2.923,2.923h98.363a2.876,2.876,0,0,0,2.923-2.923V65.723A2.876,2.876,0,0,0,110.286,62.8Z",
    transform: "translate(-9 13.8)",
    fill: "rgba(var(--secondaryColorRGB),0.2)",
    stroke: "var(--secondaryColor)",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadVideo);
export default __webpack_public_path__ + "static/media/upload-video.bb245123a1900ff75d5024400262a7e1.svg";
export { ForwardRef as ReactComponent };